import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ripple, initTE } from 'tw-elements';
import { v4 as uuidv4 } from 'uuid';
import { SpinnerComponent } from '../spinner/spinner.component';
import { IconsComponent } from '../icons/icons.component';

@Component({
  selector: 'mg-button',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, IconsComponent],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, AfterViewInit {
  @Input() id!: string;

  @Input() disabled = false;
  @Input() loading = false;
  @Input() type:
    | 'primary'
    | 'secondary'
    | 'alternative'
    | 'disabled'
    | 'disabled-alternative' = 'primary';
  @Input() isCategory = false;
  @Input() isCentered = true;
  @Input() iconName!: string;
  @Input() isReversed = false;
  @Input() btnType: 'button' | 'submit' = 'button';
  @Input() isPlanBtn = false;
  isIconBtn = false;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    const spanElement = this.elementRef.nativeElement.querySelector('span');
    if (spanElement?.textContent) {
      if (spanElement.textContent.trim().length === 0 && this.iconName) {
        this.isIconBtn = true;
      }
    }
  }

  ngOnInit() {
    initTE({ Ripple });

    if (!this.id) this.id = `button-${uuidv4()}`;
  }
}
